//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_USUARIOS_INSTITUCIONALES = "obtenerUsuariosInstitucionales";
export const OBTENER_USUARIO_INSTITUCION = "obtenerUsuarioInstitucional";
export const REGISTRAR_USUARIO_INSTITUCIONAL = "registrarUsuarioInstitucional";
export const ACTUALIZAR_USUARIO_INSTITUCIONAL = "actualizarUsuarioInstitucional";

export const OBTENER_REVISORES_INSTITUCION = "obtenerUsuariosRevisoresInstitucion";
export const OBTENER_REVISORES_ACTIVOS_INSTITUCION = "obtenerUsuariosRevisoresActivosInstitucion";

export const OBTENER_APROBADORES_INSTITUCION = "obtenerUsuariosAprobadoresInstitucion";
export const OBTENER_APROBADORES_ACTIVOS_INSTITUCION = "obtenerUsuariosAprobadoresActivosInstitucion";

export const OBTENER_APROBADORES_REVISORES_INSTITUCION = "obtenerUsuariosAprobadoresRevisoresInstitucion";
export const OBTENER_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO = "obtenerAprobadoresRevisoresAsignadosMuniPeriodo";

export const ASIGNAR_APROBADORES_REVISORES_MUNI_PERIODO = "asignarAprobadoresRevisoresMuniPeriodo";
export const OBTENER_ASIGNACION_APROBADOR_REVISOR_MUNI = "obtenerAsignacionAprobadorRevisorMuni";
export const ACTUALIZAR_ASIGNACION_APROBADORES_REVISORES_MUNI_PERIODO = "actualizarAsignacionAprobadorRevisorMuni";

export const GET_CURRENT_ROLES_REVISION = "getCurrentRolRevision";

export const GET_CURRENT_ROLES_APROBACION = "getCurrentRolAprobacion";


// mutation types
export const SET_USUARIOS_INSTITUCIONALES = "setUsuariosInstitucionales";
export const SET_USUARIO_INSTITUCIONAL = "setUsuarioInstitucional";

export const SET_USUARIOS_REVISORES_INSTITUCIONALES = "setUsuariosRevisoresInstitucionales";
export const SET_USUARIOS_APROBADORES_INSTITUCIONALES = "setUsuariosAprobadoresInstitucionales";
export const SET_USUARIOS_APROBADORES_REVISORES_INSTITUCIONALES = "setUsuariosAprobadoresRevisoresInstitucionales";
export const SET_USUARIOS_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO = "setUsuariosAprobadoresRevisoresAsignadosMuniPeriodo";

export const SET_ROLES_REVISION = "setRolUsuarioRevision";


export const SET_ROLES_APROBACION = "setRolUsuarioAprobacion";


const state = {
    usuariosInstitucionales: [],
    usuariosAprobadoresInstitucionales: [],
    usuariosRevisoresInstitucionales: [],
    usuariosAprobadoresRevisoresInstitucionales: [],
    usuarioInstitucional:[],
    usuariosAprobadoresRevisoresAsignados: [],
    rolAprobacionInstitucionAsignados: [],
    rolRevisionInstitucionAsignados: []
}

const getters = {
    obtenerUsuariosInstitucionales(state) {
      return state.usuariosInstitucionales;
    },

    getCurrentRolRevision(state){
        return state.rolRevisionInstitucionAsignados;
    },

    getCurrentRolAprobacion(state){
        return state.rolAprobacionInstitucionAsignados;
    }
}

const actions = {
    async [OBTENER_USUARIOS_INSTITUCIONALES](context, institucionId) {

        
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuario/Rol/${2}/${3}/${institucionId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_INSTITUCIONALES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Obtener Revisores por institución
     * @param {*} context 
     * @param {*} institucionId 
     * @returns 
     */
    async [OBTENER_REVISORES_INSTITUCION](context, institucionId) {

        
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuario/Rol/${3}/${3}/${institucionId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_REVISORES_INSTITUCIONALES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },



    /**
     * Obtener Revisores activos por institución
     * @param {*} context 
     * @param {*} institucionId 
     * @returns 
     */
     async [OBTENER_REVISORES_ACTIVOS_INSTITUCION](context, institucionId) {

        
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuario/Rol/Activos/${3}/${3}/${institucionId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_REVISORES_INSTITUCIONALES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Obtener Los aprobadores por institucion
     * @param {*} context 
     * @param {*} institucionId 
     * @returns 
     */
    async [OBTENER_APROBADORES_INSTITUCION](context, institucionId) {
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuario/Rol/${2}/${2}/${institucionId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_APROBADORES_INSTITUCIONALES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    /**
     * Obtener Los aprobadores activos por institucion
     * @param {*} context 
     * @param {*} institucionId 
     * @returns 
     */
     async [OBTENER_APROBADORES_ACTIVOS_INSTITUCION](context, institucionId) {
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuario/Rol/Activos/${2}/${2}/${institucionId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_APROBADORES_INSTITUCIONALES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    

    /**
     * Obtener Aprobaroes y revisores por institucion
     * @param {*} context 
     * @param {*} institucionId 
     * @returns 
     */
    async [OBTENER_APROBADORES_REVISORES_INSTITUCION](context, institucionId) {

        
        /*
        * Si el estado es null va a traer a todas los UsuariosInstitucionales, de lo contrario va a traer los UsuariosInstitucionales por estado
        *
        */
       /////////////////////////////////////// USAR EL ID DE LA INSTITUCIÓN DEL USUARIO QUE ESTPÁ LOGUEADO POR EL MOMENTO ESTÁ QUEMADO A 1
        // api/Usuario/Rol/IdRolInicial/IdRolFinal/IdInstitucion

        let endpoint =  `api/Usuario/Rol/${2}/${3}/${institucionId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_APROBADORES_REVISORES_INSTITUCIONALES, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },



    async [OBTENER_USUARIO_INSTITUCION](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Usuarios/`)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INSTITUCIONAL, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [REGISTRAR_USUARIO_INSTITUCIONAL](context, datosUsuario){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios`, datosUsuario)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INSTITUCIONAL, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_USUARIO_INSTITUCIONAL](context, datosUsuarioInstitucional){
        let id = datosUsuarioInstitucional.id;
        
        return new Promise(resolve => {
            ApiService.update(`apiconsume/update/${id}?endpoint=api/Usuarios/`, datosUsuarioInstitucional)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INSTITUCIONAL, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },



    /**
     * Obtener todos los revisores y aprobadores por periodo y departamento
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO](context, datos){

        let idDepto = datos.deptoId;
        let idPeriodo = datos.periodoId;
        let idInstitucion = datos.institucionId;

        let endpoint = `/api/AsignarRevApr/${idDepto}/${idPeriodo}/${idInstitucion}`;
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIOS_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO, data.data);
                    }
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });     
    },

    /**
     * Asignar Aprobador y Revisor a una o varias municipalidades de un departamento
     * @param {*} context 
     * @param {*} datos 
     */
    async [ASIGNAR_APROBADORES_REVISORES_MUNI_PERIODO](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/AsignarRevApr`, datos)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INSTITUCIONAL, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Obtener la asignacion de aprobador/revisor por muni y periodo
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_ASIGNACION_APROBADOR_REVISOR_MUNI](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/AsignarRevApr/`)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INSTITUCIONAL, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    /**
     * Actualizar una asignación de aprobador, revisor muni periodo
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    
    async [ACTUALIZAR_ASIGNACION_APROBADORES_REVISORES_MUNI_PERIODO](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/AsignarRevApr/`, datos)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INSTITUCIONAL, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error);
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    /**
     * Validar que el usuario tenga roles de revision asignados a un periodo
     * @param {*} context 
     * @returns 
     */

    [GET_CURRENT_ROLES_REVISION](context, usuarioId) {
        return new Promise(resolve => {
          ApiService.get(`apiconsume/edit/${usuarioId}?endpoint=api/AsignarRevApr/GetRolRevisionAsignados/`)
            .then(({ data }) => {
            
              if(data.status==200){
                //console.log(data.data.roles)
                context.commit(SET_ROLES_REVISION, data.data);
              }
              resolve(data);
            })
            .catch(({ response }) => {
              
             // context.commit(SET_ERROR, response);
              resolve(response);
            });
        });
      },
    

      /**
     * Validar que el usuario tenga roles de aprobacion asignados a un periodo
     * @param {*} context 
     * @returns 
     */

    [GET_CURRENT_ROLES_APROBACION](context, usuarioId) {
        console.log(usuarioId)
        return new Promise(resolve => {
          ApiService.get(`apiconsume/edit/${usuarioId}?endpoint=api/AsignarRevApr/GetRolAprobacionAsignados/`)
            .then(({ data }) => {
            
              if(data.status==200){
                //console.log(data.data.roles)
                context.commit(SET_ROLES_APROBACION, data.data);
              }
              resolve(data);
            })
            .catch(({ response }) => {
              
              //context.commit(SET_ERROR, response);
              resolve(response);
            });
        });
      },



    


}

const mutations = {
    [SET_USUARIOS_INSTITUCIONALES](state, data) {
        state.usuariosInstitucionales = data;
    },

    [SET_USUARIOS_REVISORES_INSTITUCIONALES](state, data) {
        state.usuariosRevisoresInstitucionales = data;
    },

    [SET_USUARIOS_APROBADORES_INSTITUCIONALES](state, data) {
        state.usuariosAprobadoresInstitucionales = data;
    },

    [SET_USUARIOS_APROBADORES_REVISORES_INSTITUCIONALES](state, data) {
        state.usuariosAprobadoresRevisoresInstitucionales = data;
    },

    [SET_USUARIO_INSTITUCIONAL](state, data) {
        state.usuarioInstitucional = data;
    },

   [SET_USUARIOS_APROBADORES_REVISORES_ASIGNADOS_MUNI_PERIODO](state, data) {
        state.usuariosAprobadoresRevisoresAsignados = data;
    },

    [SET_ROLES_REVISION](state, data) {
        state.rolReviosionInstitucionAsignados = data;
    },

    [SET_ROLES_APROBACION](state, data) {
        state.rolAprobacionInstitucionAsignados = data;
    },

    
}


export default {
    state,
    getters,
    actions,
    mutations
}